module.exports = __webpack_public_path__ + "img/CO.72f76a8e.svg";